import React from 'react'
import { Form, Dropdown } from 'semantic-ui-react'

interface WorkspaceWeekStartDayProps {
  selectedWeekStartDay: 'monday' | 'sunday'
  handleChangeWeekStartDay: (
    event: React.SyntheticEvent,
    data: { value: 'monday' | 'sunday' }
  ) => void
  disabled?: boolean
}

const WEEK_START_DAY_OPTIONS = [
  { key: 'monday', value: 'monday', text: 'Monday' },
  { key: 'sunday', value: 'sunday', text: 'Sunday' },
]

export default function WorkspaceWeekStartDay({
  selectedWeekStartDay,
  handleChangeWeekStartDay,
  disabled,
}: WorkspaceWeekStartDayProps) {
  return (
    <React.Fragment>
      <h3 className="flex items-center ui header">Week start day settings</h3>
      <p>
        This setting works with your workspace time zone to calculate This week and Last week across
        dashboards, reports, and filters.
      </p>

      <Form.Field>
        <label>Week start day</label>
        <Dropdown
          value={selectedWeekStartDay}
          options={WEEK_START_DAY_OPTIONS}
          selection
          fluid
          onChange={handleChangeWeekStartDay}
          disabled={disabled}
        />
      </Form.Field>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/WorkspaceWeekStartDay/index.tsx